module.exports = __webpack_public_path__ + "static/media/checkbox-checked-darkgreen.b0bb69d1.svg";